<div class='score'>
    {{ totalGrossScore() }}
    <div class='extra-score'>
           <span>
                {{ shortLabel(scoringSettings().scoringMethod, scoringSettings().handicapMode) }}
           </span>
        <span>
                {{ totalScorePoints() }}
            </span>
    </div>
</div>